'use client';
import React, { useState } from 'react';
import FlaggedProfilesTable from './FlaggedProfilesTable';
import FlaggedImagesTable from './FlaggedImagesTable';
import FlaggedGuestbookTable from './FlaggedGuestbookTable';
import AIQueueTable from './AIQueueTable';

const TABS = [
  { id: 'profiles', label: 'Flagged Profiles', badge: 3 },
  { id: 'images', label: 'Flagged Images', badge: 7 },
  { id: 'guestbook', label: 'Guestbook Entries', badge: 2 },
  { id: 'ai', label: 'AI Queue', badge: 14 },
];

export default function ModerationTabs() {
  const [active, setActive] = useState('profiles');

  return (
    <div>
      {/* Tab bar */}
      <div className="flex gap-1 bg-muted p-1 rounded-xl mb-6 overflow-x-auto scrollbar-thin w-fit">
        {TABS?.map((tab) => (
          <button
            key={`modtab-${tab?.id}`}
            onClick={() => setActive(tab?.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-600 transition-all whitespace-nowrap
              ${active === tab?.id ? 'bg-card text-foreground shadow-card' : 'text-muted-foreground hover:text-foreground'}`}
          >
            {tab?.label}
            <span className={`text-[10px] font-700 px-1.5 py-0.5 rounded-full min-w-[18px] text-center
              ${active === tab?.id ? 'bg-danger text-white' : 'bg-border text-muted-foreground'}`}>
              {tab?.badge}
            </span>
          </button>
        ))}
      </div>
      <div className="fade-in">
        {active === 'profiles' && <FlaggedProfilesTable />}
        {active === 'images' && <FlaggedImagesTable />}
        {active === 'guestbook' && <FlaggedGuestbookTable />}
        {active === 'ai' && <AIQueueTable />}
      </div>
    </div>
  );
}